// ** React Imports
import { useState, Fragment, useEffect, useRef } from "react";
import * as React from "react";
// ** Next Import
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import LoadingButton from "@mui/lab/LoadingButton";
import Download from "@mui/icons-material/Download";
import fileDownload from "js-file-download";
import Headroom from "react-headroom";
import ArchiveIcon from "@mui/icons-material/Archive";
import ClickAwayListener from "@mui/material/ClickAwayListener";
// ** MUI Imports
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Moment from "moment";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Badge from "@mui/material/Badge";
// import Avatar from '@mui/material/Avatar'
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import SendIcon from "@mui/icons-material/Send";
import ArchiveOutlinedIcon from "@mui/icons-material/Archive";
// ** Icons Imports
// import CogOutline from 'mdi-material-ui/CogOutline'
// import CurrencyUsd from 'mdi-material-ui/CurrencyUsd'
// import EmailOutline from 'mdi-material-ui/EmailOutline'
// import AccountOutline from 'mdi-material-ui/AccountOutline'
// import MessageOutline from 'mdi-material-ui/MessageOutline'
// import HelpCircleOutline from 'mdi-material-ui/HelpCircleOutline'
import axios from "axios";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import MailIcon from "@mui/icons-material/Mail";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Backdrop } from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
// Material-UI Components
import Chip from "@mui/material/Chip";
import PersonIcon from "@mui/icons-material/Person";
import AttachmentIcon from "@mui/icons-material/Attachment";
import ReplyIcon from "@mui/icons-material/Reply";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import { useAuth } from 'src/hooks/useAuth'
import {
  Autocomplete,
  Button,
  Grid,
  TextareaAutosize,
  TextField,
  Popover,
  IconButton,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import { useAlert } from "react-alert";
import { Container } from "@mui/system";
import { WEBKIT } from "stylis";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import ReactSelect from "react-select";
import AddTaskIcon from "@mui/icons-material/AddTask";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Documents from "../../../Pages/Documents";
import PatientRegistration from "../../../Pages/PatientRegistration";

// import { ChartLineStacked } from 'mdi-material-ui'

// ** Styled Components
const BadgeContentSpan = styled("span")(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: theme.palette.success.main,
  boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
}));

const NotificationDropdown = (props) => {
  const [refresh, setRefresh] = useState(false);
  const rights = useSelector((state) => state.login.rights);

  //  const history = createBrowserHistory({ forceRefresh: true })
  // API Authanticatiion
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const router = useNavigate();

  const handleDropdownOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleDropdownClose = (url) => {
    if (url) {
      router.push(url);
    }
    setAnchorEl(null);
  };
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [Delbyid, setDelbyid] = useState(false);
  const [Patientiidresolve, setPatientiidresolve] = useState("");
  const [subject1, setsubject1] = useState("");
  const [Name1, setName1] = useState("");
  const [assginedto, setassginedto] = useState("");
  const [commentsnotifcation, setcommentsnotifcation] = useState("");
  const [date, setdate] = useState("");
  const handleDelete = () => {
    const postData = {
      id: Delbyid,
      resolved: false,
      patientName: Name1,
      patientId: Patientiidresolve,
      subject: subject1,
      assignedTo: assginedto,
      comments: commentsnotifcation,
      createdDate: date,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Notifications/AddNotifications`,
        postData,
        {
          headers,
        },
      )
      .then((response) => {
        setRefresh(true);
        RefreshApis();
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });

    // Close the dialog
    setDialogOpen(false);
  };

  const styles = {
    py: 2,
    px: 4,
    width: "100%",
    display: "flex",
    alignItems: "center",
    color: "text.primary",
    textDecoration: "none",
    "& svg": {
      fontSize: "1.375rem",
      color: "text.secondary",
    },
  };

  //// Add Modal
  const [TmdId, setcolumnID] = useState(
    props.columnID !== undefined ? props.columnID : 0,
  );

  const [open, setOpen] = React.useState(false);
  const handleOpen = (row) => {
    setOpen(true);
    setSelectedRowData(row);
    setAssignedTo(row.createdBy);
  };
  const [patientSelected, setPatientSelected] = React.useState(false);
  const [DocumentOpenError, setDocumentOpenError] = useState("");

  const handleClose = () => {
    reset();
    setOpen(false);
    setBool(false);
    setdueDate(Moment().format("YYYY-MM-DD"));
    setsubject("");
    setIsSubmitting(false);
    setAssignedTo("");
    setSelectedRowData({});
    setPatientSelected(false);
    setDocumentOpenError("");
    setcolumnID(0);
  };
  const [openDocument, setOpenDocument] = React.useState(false);

  const handleCloseDocument = () => {
    setOpenDocument(false);
  };
  const Modelstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: "#F0FFFF",
    border: "2px solid #377562",
    boxShadow: 24,
    p: 2,
    overflow: "auto",
  };
  const style = {
    position: "absolute",
    width: 399,
    mt: 50, // Adjust margin-top if needed
    height: 370, // Set a fixed height to allow scrolling
    overflowY: "auto", // Enable vertical scrolling
    overflowX: "hidden", // Hide horizontal scroll
    alignItems: "center",
    color: "text.primary",
    textDecoration: "none",
    "& svg": {
      fontSize: "1.375rem",
      color: "text.secondary",
    },
  };
  const stylesss = {
    position: "absolute",
    width: 399,
    mt: 50, // Adjust margin-top if needed
    height: 334, // Set a fixed height to allow scrolling
    overflowY: "auto", // Enable vertical scrolling
    overflowX: "hidden", // Hide horizontal scroll
    alignItems: "center",
    color: "text.primary",
    textDecoration: "none",
    "& svg": {
      fontSize: "1.375rem",
      color: "text.secondary",
    },
  };

  const [value, setvalue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setvalue(newValue);
    // RefreshApis();
  fetchNotifications(newValue);

  };
  const alert = useAlert();
  const [spinner, setSpinner] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const validationSchema = Yup.object({
    // emailAddress: Yup.string().required('Email is required'),
    // emailAddress: Yup.string()
    subject: Yup.string().required("Subject is required"),
    patientName: Yup.string().required("Patient name is required"),

    //   .required('Email is invalid')
    //   .email('Email is invalid'),
    // patientName: Yup.string().required('Patient Name is required'),
    // assignedTo: Yup.string().required('Please Select a User'),
    // createdDate: Yup.date().required('Please Select a date'),
  });
  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    resolver: yupResolver(validationSchema),
  });
  const download = (url, filename) => {
    setSpinner(true);
    setSubmitting(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${url}`,
        {
          headers,
          responseType: "blob",
        },
      )
      .then((res) => {
        setopendocs(false);
        setSpinner(false);
        setSubmitting(false);
        fileDownload(res, filename);
      })
      .catch((err) => {
        setSubmitting(false);
      });
  };
  const [dob, setdob] = React.useState();
  const [dueDate, setdueDate] = React.useState(Moment().format("YYYY-MM-DD"));
  const [patientData, setPatientData] = React.useState([]);
  const [patient, setPatient] = React.useState(false);

  const [patientId, setPatientId] = React.useState("");
  const [openDetails, setOpenDetails] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [CountMessage, setMessage] = useState("New");

  // const [jsonR, setJsonR] = useState([]);
  // const newPost = {
  //   lastName: '',
  //   firstName: '',
  // };

  // useEffect(() => {
  //   axios
  //     .post(`${process.env.REACT_APP_API_URL}/Patients/searchPatient`, newPost, { headers })
  //     .then(response => {
  //       setJsonR(response);
  //       console.log('autoData', response);
  //     })
  //     .catch(error => {
  //       console.error('There was an error!', error);
  //     });
  // }, []); // Fix: Add newPost to the dependency array
  const searchData = {
    id: 0,
    patientId: "",
    firstName: "",
    lastName: "",
  };

  // useEffect(() => {
  //   // Filter patientData to remove the selected patient
  //   if (selectedPatient) {
  //     setFilteredOptions(
  //       patientData.filter(
  //         option =>
  //           `${option.firstName} ${option.lastName}` !== `${selectedPatient.firstName} ${selectedPatient.lastName}`,
  //         )
  //             );
  //   } else {
  //     // If no patient is selected, show all options
  //     setFilteredOptions(patientData);
  //   }
  // }, [selectedPatient, patientData]);

  const onOptionChange = (event, value) => {
    setSelectedPatient(value); // Update the selected patient state
    // Handle patient selection if needed
    if (value && value.id > 0) {
      setPatientId(value.id);
      // setPatientId(value.patientName)
    } else {
      setPatientId(0);
    }
  };

  function applyRefresh() {
    setRefresh(!refresh);
  }
  ///Save Apis
  const searchValues = {
    patientId: patientId,
    description: "",
    assignedTo: "",
    resolvedDate: "",
    createdDate: "",
    userType: "",
    comments: "",
    subject: "",
  };

  // Notification Dropdown
  const [patientName, setPatientName] = useState("");
  const [patientID, setPatientID] = React.useState(props.patientId);
  const [isLoading, setLoading] = useState("");
  const [isLoading1, setLoading1] = useState("");
  const [patientNamee, setPatientNamee] = useState("");
  const [Notification, setNotification] = useState(null);
  const [Data, setData] = useState(null);
  const [isChecked, setIsChecked] = useState("all");
  const [ShowAsList, setShowAsList] = useState(false);
  const [ArchiveData, setArchiveData] = useState(null);
  const [Notification1, setNotification1] = useState(null);

  const [Totalcount, setTotalcount] = useState(0);
  const [TotalcountResolved, setTotalcountResolved] = useState(0);

  const [selectedRow, setselectedRow] = useState("");
  const [id, setid] = useState("");
  const [documentsName, setdocumentsName] = useState("");
  const checkstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 500,
    padding: "20px",
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    overflowY: "auto",
  };
  // useEffect(() => {
  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/Notifications/getNotifications?resolved=${true}`, { headers })
  //     .then(response => {
  //       console.log('response.mydata: ', response)
  //       setNotification(response)
  //       setTotalcount(response?.length)
  //       setLoading(false)
  //        setRefresh(true)

  //     })
  //     .catch(error => {
  //       console.error('There was an error!', error)
  //     })
  // }, [])

  // useEffect(() => {
  //   if (Totalcount > 0) {
  //     axios
  //       .get(`${process.env.REACT_APP_API_URL}/Notifications/getNotifications?resolved=${true}`, { headers })
  //       .then(response => {

  //         alert.success('New notification added!.', {
  //           type: 'success',
  //           onClose: () => {
  //             setTotalcount(Totalcount + 1)
  //           }

  //         })

  //       })
  //       .catch(error => {
  //         console.error('There was an error!', error)
  //       })
  //   }
  // }, [])

  const [Bool, setBool] = useState(false);
  const [CreatedBy, setCreatedBy] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [assignedToError, setassignedToError] = useState(false);
  const [refreshChats, setrefreshChats] = useState(false);
  const onSubmit = (data) => {
    if (!Bool && !assignedTo) {
      setassignedToError(true);
      return;
    }
    const postData = {
      ...searchValues,
      description: data.description,
      assignedTo: assignedTo,
      patientId: patientID,
      patientName: data.patientName,
      resolvedDate: data.resolvedDate,
      createdDate: dueDate,
      userType: data.userType,
      comments: data.comments,
      subject: subject,
      createdBy: CreatedBy,
      id: TmdId,
    };
    if (Bool == true) {
      postData.id = TmdId;
      postData.createdBy = CreatedBy;
      postData.description = data.description;
      postData.assignedTo = assignedTo;
      postData.patientId = patientID;
      postData.inactive = false;
      postData.patientName = selectedRowData.patientName;
      postData.resolvedDate = data.resolvedDate;
      postData.createdDate = data.createdDate;
      postData.userType = data.userType;
      postData.subject = data.subject;
      postData.parentId = selectedRowData.parentId
        ? selectedRowData.parentId
        : selectedRowData.id;
    }
    // console.log('Onsubmit',postData)
    setIsSubmitting(true);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Notifications/AddNotifications`,
        postData,
        { headers },
      )
      .then((response) => {
        setIsSubmitting(true);
        RefreshApis();
        setrefreshChats((prev) => !prev);
        alert.success("Record saved successfully.", {
          type: "success",
          onClose: () => {
            handleClose();
            applyRefresh();
          },
        });
      })
      .catch((error) => {
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });
  };
  

const SubmitAndArchived = async (data) => {
  if (!Bool && !assignedTo) {
    setassignedToError(true);
    return;
  }

  const postData = {
    ...searchValues,
    description: data.description,
    assignedTo,
    patientId: patientID,
    patientName: data.patientName,
    resolvedDate: data.resolvedDate,
    createdDate: dueDate,
    userType: data.userType,
    comments: data.comments,
    subject,
    createdBy: CreatedBy,
    id: TmdId,
  };

  if (Bool === true) {
    postData.id = TmdId;
    postData.createdBy = CreatedBy;
    postData.description = data.description;
    postData.assignedTo = assignedTo;
    postData.patientId = patientID;
    postData.inactive = false;
    postData.patientName = selectedRowData.patientName;
    postData.resolvedDate = data.resolvedDate;
    postData.createdDate = data.createdDate;
    postData.userType = data.userType;
    postData.subject = data.subject;

    postData.parentId =
      selectedRowData.parentId || selectedRowData.id;
  }

  setIsSubmitting(true);

  try {
    // Step 1: Save Notification
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/Notifications/AddNotifications`,
      postData,
      { headers }
    );

    // Step 2: Determine Archive ID by priority
    const archiveId =
      (selectedRowData?.id && selectedRowData.id !== 0)
        ? selectedRowData.id
        : (selectedRowData?.parentId && selectedRowData.parentId !== 0)
          ? selectedRowData.parentId
          : response?.id;

    // Step 3: Archive Notification
    if (archiveId && archiveId !== 0) {
      await axios.get(
        `${process.env.REACT_APP_API_URL}/Notifications/Archived?id=${archiveId}&resolved=true`,
        { headers }
      );
    } else {
      throw new Error("Archive ID not found.");
    }

    // Step 4: Refresh APIs
    RefreshApis();
    setrefreshChats((prev) => !prev);

    alert.success("Record saved and archived successfully.", {
      type: "success",
      onClose: () => {
        handleClose();
        applyRefresh();
      },
    });

  } catch (error) {
    console.error("There was an error!", error);

    alert.success(`Error: ${error.message}`, {
      type: "error",
    });
  } finally {
    setIsSubmitting(false);
  }
};


  useEffect(() => {
    setRefresh(true);
  }, [refresh]);
  useEffect(() => {
    RefreshApis();
  }, [isChecked]);
  const [subject, setsubject] = useState("");

  const [resolvedComments, setResolvedComments] = useState("");
  const [resolvedDate, setResolvedDate] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);

  const saveData = (data) => {
    // const currentDate =  Moment().toDate().format("DD-MM-YYYY");
    const postData = {
      ...data,
      resolvedDate: Moment().format("YYYY-MM-DD"),
      resolvedComments: resolvedComments,
      id: selectedRow,
      resolved: true,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Notifications/addNotifications`,
        postData,
        { headers },
      )
      .then((response) => {
        setid(null);

        RefreshApis();
        alert.success("Issue Archieved successfully.", {
          type: "success",
          onClose: () => {
            setTotalcount(Totalcount - 1);
            setSubmitting(false);
            setRefresh(true);
            reset();
          },
        });
      })
      .catch((error) => {
        setSubmitting(false);
        alert.error(`Error ${error.message}`, {
          type: "error",
          onClose: () => {
            console.log(`Error Alert: ${error.message}`);
          },
        });
        setRefresh(true);
      });
    setRefresh(true);
  };
  // const [admin, setadmin] = useState('')
  const errorMesage = {
    color: "red",
    fontSize: "13px",
    marign: "0px",
  };
  const zipCodeListStyle = {
    cursor: "pointer",
    hover: {
      background: "#3b3b3b !important",
      color: "rgba(5, 152, 236, 0.637) !important",
    },
    color: "green",
    selection: {
      background: "#D7624E",
      color: "white",
    },
  };
  const PatientStyle = {
    cursor: "pointer",
    hover: {
      background: "#3b3b3b !important",
      color: "rgba(5, 152, 236, 0.637) !important",
    },
    color: "green",
    selection: {
      background: "#D7624E",
      color: "white",
    },
  };
  const [practiceID, setPracticeID] = useState("");
  // useEffect(() => {
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}/Notifications/getNotifications?messageType=${isChecked}`,
  //       { headers },
  //     )
  //     .then((response) => {
  //       const count = response.filter(
  //         (notification) =>
  //           notification.seen == null || notification.seen == false,
  //       ).length;
  //       setTotalcount(count);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching notifications:", error);
  //     });
  // }, []);
  const [timeLeft, setTimeLeft] = useState(120);
  useEffect(() => {
    const fetchNotifications = () => {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Notifications/getNotifications?messageType=${isChecked}`,
          { headers },
        )
        .then((response) => {
          // setNotification(response)
          // setPracticeID(response.practiceId)
          setLoading(false);
          const count = response.filter(
            (notification) =>
              notification.seen == null || notification.seen == false,
          ).length;
          setTotalcount(count);

          // RefreshApis()
        })
        .catch((error) => {
          console.error(
            "There was an error fetching the notifications!",
            error,
          );
        });
    };

    fetchNotifications();

    const timerId = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          fetchNotifications();
          RefreshApis();
          return 120;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secondsLeft = seconds % 60;
    return `${minutes}:${secondsLeft < 10 ? "0" : ""}${secondsLeft}`;
  };
  const [Inboxcount, setInboxcount] = useState(0);
  const [SentCount, setSentCount] = useState(0);
  const [ArchievedCount, setArchievedCount] = useState(0);
const fetchNotifications = async (currentValue) => {
  try {
    setLoading(true);
    setRefresh(true);

    if (currentValue === 1) {
      // Sent
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Notifications/getNotifications?messageType=sent`,
        { headers },
      );

      setPracticeID(response.practiceId);
      setNotification1(response);
      setSentCount(response.length);

    } else if (currentValue === 0) {
      // Inbox
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Notifications/getNotifications?messageType=${isChecked}`,
        { headers },
      );

      setPracticeID(response.practiceId);
      setData(response);

      const count = response.filter(
        (notification) =>
          notification.seen == null || notification.seen == false,
      ).length;

      setTotalcount(count);
      setInboxcount(response.length);

    } else if (currentValue === 2) {
      // Archive
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Notifications/getNotifications?messageType=archive&resolved=true&showAllPractices=true`,
        { headers },
      );

      setArchiveData(response);
      setArchievedCount(response.length);
    }
  } catch (error) {
    console.error("There was an error!", error);
  } finally {
    setLoading(false);
  }
};


const handleDropdownOpenNotification = (event) => {
  setNotification(event.currentTarget);
  fetchNotifications(value);
};


const RefreshApis = () => {
  // Only ONE API call
  fetchNotifications(value);
};

  // const handleDropdownOpenNotification = (event) => {
  //   setNotification(event.currentTarget);
  //   setLoading(true);
  //   setRefresh(true);
  //     if (value === 1) {
  //   axios
  //     .get(
  //       `${
  //         process.env.REACT_APP_API_URL
  //       }/Notifications/getNotifications?messageType=${"sent"}`,
  //       { headers },
  //     )
  //     .then((responses) => {
  //       setPracticeID(responses.practiceId);
  //       setNotification1(responses);
  //       setSentCount(responses.length);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("There was an error!", error);
  //     });
  //     } else if (value === 0) {
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}/Notifications/getNotifications?messageType=${isChecked}`,
  //       { headers },
  //     )
  //     .then((response) => {
  //       setPracticeID(response.practiceId);
  //       setData(response);
  //       const count = response.filter(
  //         (notification) =>
  //           notification.seen == null || notification.seen == false,
  //       ).length;
  //       setTotalcount(count);
  //       setInboxcount(response.length);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("There was an error!", error);
  //     });
  //     } else if (value === 2) {

  //   axios
  //     .get(
  //       `${
  //         process.env.REACT_APP_API_URL
  //       }/Notifications/getNotifications?messageType=${"archive"}&resolved=${true}&showAllPractices=${true}`,
  //       { headers },
  //     )
  //     .then((responses) => {
  //       setArchiveData(responses);
  //       setArchievedCount(responses.length);
  //     })
  //     .catch((error) => {
  //       console.error("There was an error!", error);
  //     });
  //   }
  // };

  // const RefreshApis = () => {
  //   setLoading(true);
  //   setRefresh(true);
  //   if (value === 1) {
  //     axios
  //       .get(
  //         `${
  //           process.env.REACT_APP_API_URL
  //         }/Notifications/getNotifications?messageType=${"sent"}`,
  //         { headers },
  //       )
  //       .then((res) => {
  //         setPracticeID(res.practiceId);
  //         // setTotalcount(res.length);
  //         setLoading(false);
  //         setNotification1(res);
  //         setSentCount(res.length);
  //         // if (isFirstCall) {
  //         //   return;
  //         // } else {
  //         //   setTotalcount(response?.length);
  //         // }
  //         // setIsFirstCall(false);
  //         // response.forEach(item => {
  //         //   const documentParts = item.documents?.split('@@');
  //         //   console.log(documentParts,'documentsName,,')
  //         //   setdocumentsName(documentParts[0]);

  //         // });
  //       })
  //       .catch((error) => {
  //         console.error("There was an error!", error);
  //       });
  //   } else if (value === 0) {
  //     axios
  //       .get(
  //         `${process.env.REACT_APP_API_URL}/Notifications/getNotifications?messageType=${isChecked}`,
  //         { headers },
  //       )
  //       .then((response) => {
  //         setPracticeID(response.practiceId);
  //         const count = response.filter(
  //           (notification) =>
  //             notification.seen == null || notification.seen == false,
  //         ).length;
  //         setTotalcount(count);
  //         setInboxcount(response.length);

  //         setData(response);

  //         // setTotalcount(response?.length)
  //         setLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error("There was an error!", error);
  //       });
  //   } else if (value === 2) {
  //     axios
  //       .get(
  //         `${
  //           process.env.REACT_APP_API_URL
  //         }/Notifications/getNotifications?messageType=${"archive"}&resolved=${true}&showAllPractices=${true} `,
  //         { headers },
  //       )
  //       .then((responses) => {
  //         setArchiveData(responses);
  //         setArchievedCount(responses.length);
  //       })
  //       .catch((error) => {
  //         console.error("There was an error!", error);
  //       });
  //   }
  // };
  const onChangeHandle = async (value) => {
    // this default api does not support searching but if you use google maps or some other use the value and post to get back you reslut and then set it using setOptions
    setLoading1(true);
    const sendData = {
      id: 0,
      lastName: value,
      firstName: "",
      ssn: "",
      status: "",
      cellPhone: "",
      address: "",
      dob: "",
      patientId: "",
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Patients/searchPatient`,
        sendData,
        { headers },
        setPatientSelected(false),
      )
      .then((response) => {
        setPatientData(response);
        setPatient(true);
        setLoading1(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoading1(false);
      });
  };

  const handleDropdownCloseNotification = (url) => {
    if (url) {
      router.push(url);
    }
    setNotification(null);
  };
  const [assignedList, setassignedList] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState({});

  const [assignedTo, setAssignedTo] = useState(null);
  // useEffect(() => {
  //   if (Bool) {
  //     setAssignedTo(selectedRowData.createdBy);
  //   }
  // }, [Bool]);
  const [practicesList, setpracticesList] = useState([]);

  const practicesListid = localStorage.getItem("default_paractice");
  const Emailaddress = localStorage.getItem("Emailaddress");
  useEffect(() => {
    // POST request using axios inside useEffect React hook
    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/UserPractices/users?tokenPracticeId=${practicesListid}&showAllPractices=${true}`,
        {
          headers,
        },
      )
      .then((response) => {
        var prac = [];
        response.forEach((field) => {
          prac.push({
            label: `${field.fullName}<${field.email}>`,
            value: field.email,
          });
        });
        setpracticesList(prac);
        // response.forEach((field) => {
        //   practicesList.push({
        //     label: field.practiceName,
        //     value: field.id,
        //   });
        // });
      })
      .catch((error) => {});

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);
  const [opendocs, setopendocs] = useState(false);
  const [urlFile, seturlFile] = useState("");
  const [urldownload, seturldownload] = useState("");
  const [DocName, setDocName] = useState("");
  const [FullDocName, setFullDocName] = useState("");
  const styleofmodal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 950,
    // height: 500,
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    p: 4,
  };
  //Reply Modal

  const [OpenReply, setOpenReply] = React.useState(false);
  const handleOpenReply = (row) => {
    setOpenReply(true);
  };
  const handleCloseReply = () => {
    reset();
    setOpenReply(false);
    setSelectedRowId(null);
  };
  const ReplyStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 500,
    padding: "10px",
    bgcolor: "background.paper",
    border: "4px solid #377562",
    borderRadius: "8px",
    boxShadow: 24,
    overflow: "auto",
    /* WebKit (Chrome, Safari) */
    "&::-webkit-scrollbar": {
      width: 8 /* Width of vertical scrollbar */,
      height: 10,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#3C7F6B",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    /* Adjust the width for the horizontal scrollbar */
    "&::-webkit-scrollbar-thumb:horizontal": {
      width: 4 /* Width of horizontal scrollbar */,
    },
    /* For Firefox */
    "&*": {
      scrollbarWidth: "thin",
    },
  };

  const formatDate = (dateString) => {
    return Moment(dateString).format("YYYY-MM-DD");
  };
  const [ReplyData, setReplyData] = useState(null);
  const [PatientDataName, setPatientDataName] = useState("");
  const [PatientDataId, setPatientdataId] = useState("");
  const [responseIds, setResponseIds] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const handleRowClickChats = (row) => {
    setSelectedRowId(row.parentId ? row.parentId : row.id);
    setOpenReply(true);
  };

  const [loadingReplies, setLoadingReplies] = useState(false);
  const fetchPatientData = async (selectedRowId) => {
    try {
      setOpenReply(true);
      setLoadingReplies(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Notifications/getNotificationsById?id=${selectedRowId}`,
        { headers },
      );
      // const Data = response.filter(item => item.id || item.parentId == rowid)
      // const filteredData = response.filter(
      //   item => item.id === rowid || item.parentId === rowid
      // );
      setReplyData(response);
      // const ids = filteredData.map(item => item.id);
      // const ids = response.map(item => item.id);
      // setResponseIds(ids);

      // const postResponse = await axios.post(
      //   `${process.env.REACT_APP_API_URL}/Notifications/addMarkNotifications`,
      //   { id: PatientDataId, seen: true },
      //   { headers }
      // );
      // RefreshApis()
      // setTotalcount(Totalcount - 1);
    } catch (error) {
      console.error("There was an error!", error);
    } finally {
      setLoadingReplies(false);
    }
  };

  useEffect(() => {
    if (selectedRowId && OpenReply) {
      fetchPatientData(selectedRowId);
    }
  }, [selectedRowId, refreshChats]);
  const messagesEndRef = useRef(null);
  useEffect(() => {
    if (!loadingReplies && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [ReplyData, loadingReplies]);
  const HandleRead = async (id) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/Notifications/addMarkNotifications`,
        { id: id, seen: true },
        { headers },
      );
      // setTotalcount(Totalcount + 1);
      // setPatientdataId("");
      RefreshApis();
    } catch (error) {
      console.error(
        "There was an error updating the notification status!",
        error,
      );
    }
  };
  const HandleUnRead = async (id) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/Notifications/addMarkNotifications`,
        { id: id, seen: false },
        { headers },
      );
      // setTotalcount(Totalcount + 1);
      RefreshApis();
      // setPatientdataId("");

      handleCloseReply();
    } catch (error) {
      console.error(
        "There was an error updating the notification status!",
        error,
      );
    }
  };

  useEffect(() => {
    if (selectedRowData) {
      setsubject(selectedRowData.subject);
      setValue("subject", selectedRowData.subject);
    }
  }, [selectedRowData]);
  useEffect(() => {
    if (selectedRowData) {
      setPatientID(selectedRowData.patientId);
      setPatientNamee(selectedRowData.patientName);
      setValue("patientName", selectedRowData.patientName || "");
      setValue("patientId", selectedRowData.patientId || null);
    }
  }, [selectedRowData]);
  const [URL, setURL] = useState("");
  const [ImageData, setImageData] = useState("");
  const [DocumentName, setdocumentName] = useState("");

  // useEffect(() => {
  //   if (OpenReply && responseIds?.length > 0) {
  //     const fetchDocumentData = async () => {
  //       try {
  //         const allDocuments = await Promise.all(
  //           responseIds.map(notificationId =>
  //             axios.get(`${process.env.REACT_APP_API_URL}/PatientDocument/notificationDocumentbyId?notificationId=${notificationId}`, { headers })
  //           )
  //         );

  //         const documentsData = allDocuments
  //           .filter(response => response && Array.isArray(response))
  //           .map(response => response)
  //           .flat();

  //         setImageData(documentsData);

  //         if (documentsData?.length > 0) {
  //           setURL(documentsData[0]?.fileUrl || '');
  //           setdocumentName(documentsData[0]?.documentName || '');
  //         } else {
  //           setURL(null);
  //           setdocumentName(null);
  //         }
  //       } catch (error) {
  //         console.error('There was an error fetching document data!', error);
  //       }
  //     };

  //     fetchDocumentData();
  //   }
  // }, [OpenReply, responseIds]);

  const [modalOpen, setModalOpen] = useState(false);
  const handleCloseImage = () => {
    setModalOpen(false);
  };

  const isImage = (url) => /\.(jpg|jpeg|png|gif)$/i.test(url);
  const isPDF = (url) => /\.pdf$/i.test(url);
  const isRTF = (url) => /\.rtf$/i.test(url);
  const [fileUrl, setFileUrl] = useState("");
  const [fileType, setFileType] = useState("");
  const [DocNameee, setDocNameee] = useState("");

  const handleViewClick = (fileUrl, documentName) => {
    var arr = documentName?.split(".");
    setDocNameee(arr?.length > 1 ? arr[1].toLowerCase() : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${fileUrl}`,
        { headers },
      )
      .then((response) => {
        setFileUrl(response);
        setModalOpen(true);
        var arr = documentName?.split(".");
        setDocNameee(arr?.length > 1 ? arr[1].toLowerCase() : "");
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const [Archived, setArchived] = useState(false);
  const [archiveSource, setArchiveSource] = useState("");

  const handleArchiveClick = (rowId, source) => {
    setselectedRow(rowId);
    setArchiveSource(source);
    setArchived(true);
  };
  const handleCloseDialog = () => {
    setArchived(false);
    setselectedRow(null);
    setArchiveSource("");
    setOpenReply(false);
  };

  const handleConfirmArchive = async () => {
    if (selectedRow) {
      // saveData(selectedRow);
      axios
        .get(
          `${
            process.env.REACT_APP_API_URL
          }/Notifications/Archived?id=${selectedRow}&resolved=${true}`,
          { headers },
        )
        .then((response) => {
          handleCloseDialog();
          RefreshApis();
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  };

  const handlecolseConfirmArchive = async () => {
    if (Delbyid) {
      // saveData(selectedRow);
      axios
        .get(
          `${
            process.env.REACT_APP_API_URL
          }/Notifications/Archived?id=${Delbyid}&resolved=${false}`,
          { headers },
        )
        .then((response) => {
          setDialogOpen(false);
          RefreshApis();
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  };
  const [openpatientreg, setOpenpatientreg] = React.useState(false);
  const [pid, setpid] = React.useState("");
  const handleOpenpatientreg = () => setOpenpatientreg(true);
  const handleClosepatientreg = () => setOpenpatientreg(false);
  const styleDetailspatient = {
    width: "90%",
    height: 600,
    bgcolor: "white",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    margin: "auto",
    marginTop: "10px",
    paddingBottom: "10px",
    padding: "20px",
    overflow: "auto",
    zIndex: 1500, // 🔥 This makes sure the modal stays on top
    scrollbarWidth: "thin",
    scrollbarColor: "#356F60 transparent",
    "&::-webkit-scrollbar": {
      width: 8,
      height: 8,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#356F60",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb:horizontal": {
      width: 4,
    },
  };

  return (
    <>
      <Modal
        open={openpatientreg}
        onClose={handleClosepatientreg}
        sx={{ zIndex: 1500 }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDetailspatient}>
          <Grid container columnSpacing={1}>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Typography style={{ fontWeight: "bold", color: "black" }}>
                Patient Registration
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Button
                onClick={handleClosepatientreg}
                style={{
                  marginTop: "0px",
                  marginBottom: "10px",
                  float: "right",
                  marginLeft: "10px",
                  width: "90px",
                  height: "35px",
                  // backgroundColor: '#A574FD',
                  color: "white",
                  fontSize: "14px",
                }}
              >
                <CancelOutlinedIcon
                  fontSize="medium"
                  style={{ color: "red", paddingRight: "5px" }}
                ></CancelOutlinedIcon>
              </Button>
            </Grid>
            <Grid item xs={12} style={{ fontWeight: 500, marginTop: "-90px" }}>
              <PatientRegistration
                callingFrom={"Authorization"}
                pid={pid}
                handleClosepatientreg={handleClosepatientreg}
              ></PatientRegistration>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal open={modalOpen} onClose={handleCloseImage}>
        <Box
          sx={{
            position: "absolute",
            top: "52%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 912,
            bgcolor: "background.paper",
            // border: '2px solid #000',
            borderColor: "#326C1D",
            border: 5,
            padding: "5px",
            borderRadius: "8px",
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* <div>

            <iframe
              // height='500'
              // width='530px'
              border='4px solid #000'
              height='500px'
              width='875px'
              src={`${imageee}`}
            ></iframe>

          </div> */}
          <div>
            {DocNameee === "jpg" ||
            DocNameee === "jpeg" ||
            DocNameee === "png" ? (
              <>
                <Grid item xs={8}>
                  <img
                    height="400px"
                    width="850px"
                    style={{ border: "4px solid #000" }}
                    src={`${fileUrl}`}
                    alt="Document"
                  />
                </Grid>
                <Grid item xs={1}></Grid>
              </>
            ) : (
              <>
                <Grid item xs={12}>
                  <iframe
                    height="400px"
                    width="850px"
                    style={{ border: "4px solid #000" }}
                    src={`${fileUrl}`}
                  ></iframe>
                </Grid>
              </>
            )}
          </div>
          <Grid
            item
            xs={2}
            style={{
              fontWeight: 500,
              marginLeft: "30px",
              marginBottom: "25px",
              marginTop: "10px",
            }}
          >
            <Button
              className="Button"
              variant="gradient"
              onClick={handleCloseImage}
              style={{
                color: "white",
                fontSize: "13px",
                height: "27px",
                marginBottom: "3px",
                float: "right",
              }}
            >
              Close
            </Button>
          </Grid>
        </Box>
      </Modal>
      <React.Fragment>
        <Badge
          overlap="circular"
          sx={{ mt: 2, cursor: "pointer" }}
          // badgeContent={<BadgeContentSpan />}
          badgeContent={CountMessage === "New" ? Totalcount : Totalcount}
          color={Totalcount > 0 ? "error" : "success"}
          backgroundColor="success"
          max={999}
          showZero={true}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <CircleNotificationsIcon
            style={{ color: "#377562" }}
            alt="John Doe"
            onClick={handleDropdownOpenNotification}
            sx={{ width: 40, height: 40 }}
          />
        </Badge>
        <Popover
          anchorEll={Notification}
          open={Boolean(Notification)}
          onClose={() => handleDropdownCloseNotification()}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "left", horizontal: "bottom" }}
          PaperProps={{
            style: {
              borderRadius: "10px",
              overflow: "hidden",
              boxShadow: "0 8px 30px rgba(0, 0, 0, 0.4)",
              width: 430,
              marginTop: 7,
              marginLeft: -15,
              paddingBottom: "20px",
              height: 530,
              overflowY: "hidden",
              overflowX: "hidden",
              top: 12,
            },
          }}
        >
          <>
            {/* <Typography sx={{ fontWeight: 'bold', fontSize: '16px', color: 'red',marginLeft:'20px' }}>{formatTime(timeLeft)}</Typography>  */}

            <Box
              sx={{ pt: 1, pb: 3 }}
              style={{ backgroundColor: "#377562", height: "49px" }}
            >
              <Box sx={{ display: "flex" }}>
                <Grid container>
                  <Grid item xs={1} style={{ marginTop: "3px" }}>
                    <Badge
                      overlap="circular"
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                    >
                      <CircleNotificationsIcon
                        style={{ color: "white" }}
                        sx={{ width: "2.5rem", height: "1.5rem" }}
                      />
                    </Badge>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: "20px",
                        color: "white",
                      }}
                    >
                      User's Messages
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Button onClick={handleDropdownOpenNotification}>
                      <CachedOutlinedIcon
                        fontSize="medium"
                        style={{
                          color: "white",
                          marginLeft: "3rem",
                        }}
                      ></CachedOutlinedIcon>
                    </Button>
                  </Grid>
                  <Grid item xs={4}>
                    <Button
                      className="Button"
                      style={{ color: "white", marginLeft: "3rem" }}
                      onClick={handleOpen}
                    >
                      Add New
                    </Button>
                  </Grid>
                </Grid>

                {/* <Box
                sx={{
                  ml: 3,
                  display: 'flex',
                  alignItems: 'flex-start',
                  flexDirection: 'column',

                }}
              >
                <Typography sx={{ fontWeight: 'bold', fontSize: '20px', color: 'white' }}>
                  Notifications
                </Typography>
              </Box>
              <Button  style={{ color: 'white', marginLeft: '5rem' }} onClick={handleOpen}>
                Add New
              </Button> */}
                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={Modelstyle}>
                    <Grid container columnSpacing={1}>
                      <Grid
                        container
                        xs={12}
                        style={{
                          fontWeight: 500,
                          backgroundColor: "#377562",
                          marginTop: "-1rem",
                        }}
                      >
                        <Grid
                          item
                          xs={12}
                          style={{
                            fontWeight: 500,
                            backgroundColor: "#377562",
                            padding: "5px",
                            display: "flex",
                          }}
                        >
                          <Modal
                            id="hello-world"
                            open={openDocument}
                            onClose={handleCloseDocument}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                            visible={true}
                            title={"Title"}
                            footer={"Footer"}
                          >
                            <Box sx={checkstyle}>
                              <Grid
                                container
                                spacing={1}
                                style={{
                                  background: "#377562",
                                  position: "sticky",
                                  marginBottom: "14px",
                                  padding: "8px",
                                  borderRadius: "8px",
                                  boxShadow:
                                    "0 4px 8px rgba(54, 118, 196, 0.5)",
                                  display: "flex",
                                }}
                              >
                                <Grid item xs={11}>
                                  <Typography
                                    style={{
                                      fontSize: "17px",
                                      fontWeight: "bold",
                                      marginLeft: "5px",
                                      color: "#fff",
                                    }}
                                  >
                                    Add Patient Document{" "}
                                  </Typography>
                                </Grid>
                                <Grid item xs={1} style={{ fontWeight: 500 }}>
                                  {/* <Button
                                    onClick={handleCloseDocument}
                                    variant="gradient"
                                    // disabled={submitting}
                                    style={{
                                      marginTop: "10px",
                                      float: "right",
                                      marginBottom: "5px",
                                      // width: "80px",
                                      height: "35px",
                                      backgroundColor: "#fff",
                                      color: "black",
                                      fontSize: "14px",
                                      cursor: 'pointer'
                                    }}

                                  
                                  > */}
                                  <CancelOutlinedIcon
                                    onClick={handleCloseDocument}
                                    fontSize="medium"
                                    style={{
                                      color: "red",
                                      cursor: "pointer",
                                      float: "right",
                                    }}
                                  ></CancelOutlinedIcon>

                                  {/* </Button> */}
                                </Grid>
                              </Grid>
                              <Grid item xs={12}>
                                <Documents
                                  callingFrom={"notifcation"}
                                  updateNotificaton={(
                                    id,
                                    _notifcationId,
                                    createdBy,
                                  ) => {
                                    setValue("id", _notifcationId);
                                    setcolumnID(_notifcationId);
                                    setCreatedBy(createdBy);
                                  }}
                                  patientid={patientID}
                                  AuthorizationFormByCPTid={TmdId}
                                  handleCloseNotification={handleCloseDocument}
                                ></Documents>
                              </Grid>
                            </Box>
                          </Modal>
                          <Grid item xs={6}>
                            <Typography
                              style={{
                                fontWeight: "bold",
                                fontSize: "18px",
                                color: "white",
                              }}
                            >
                              Add Notification
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-end",
                                width: "100%",
                              }}
                            >
                              <Button
                                // onClick={() => setOpenDocument(true)}
                                onClick={() => {
                                  if (!patientID) {
                                    setDocumentOpenError(
                                      "⚠️ Please select a patient first.",
                                    );
                                    return;
                                  }
                                  setOpenDocument(true);
                                }}
                                className="Button"
                                variant="gradient"
                                color="info"
                                size="small"
                                style={{
                                  width: "200px",
                                  height: "33px",
                                  color: "white",
                                  fontSize: "14px",
                                }}
                              >
                                <AddOutlinedIcon
                                  fontSize="medium"
                                  style={{
                                    color: "white",
                                    paddingRight: "4px",
                                    paddingBottom: "2px",
                                  }}
                                />
                                Add Document
                              </Button>
                              {TmdId > 0 && (
                                <span
                                  style={{
                                    marginTop: "8px",
                                    color: "#fff",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    width: "100%",
                                    textAlign: "right",
                                  }}
                                >
                                  ✅ Your document has been submitted.
                                </span>
                              )}
                              {DocumentOpenError && (
                                <span
                                  style={{
                                    marginTop: "8px",
                                    color: "#b92727ff",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    width: "100%",
                                    textAlign: "right",
                                  }}
                                >
                                  {DocumentOpenError}
                                </span>
                              )}
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={6}
                        style={{ fontWeight: 500, marginTop: "20px" }}
                      >
                        <Typography color="black" fontSize="15px">
                          Patient's Last Name
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{ fontWeight: 500, marginTop: "20px" }}
                      >
                        <Typography color="black" fontSize="15px">
                          Subject
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <ClickAwayListener
                          onClickAway={() => setPatient(false)}
                        >
                          <TextField
                            autoComplete="off"
                            // isClearable
                            {...register("patientName")}
                            size="small"
                            fullWidth
                            placeholder="Patient"
                            {...(selectedRowData.patientName
                              ? { value: selectedRowData.patientName }
                              : {})}
                            //  value={selectedRowData.patientName||''}
                            error={!!errors.patientName}
                            helperText={
                              errors.patientName
                                ? errors.patientName.message
                                : ""
                            }
                            onKeyUp={(ev) => {
                              // dont fire API if the user delete or not entered anything
                              if (
                                ev.target.value !== null &&
                                ev.target.value !== "" &&
                                ev.target.value?.length > 0
                              ) {
                                onChangeHandle(ev.target.value);
                                setSearchText(ev.target.value);
                              } else {
                                setPatientData([]);
                                setPatientSelected(false);
                                setPatient(false);
                                setSearchText("");
                              }
                            }}

                            // error={errors.patientName}
                          />
                        </ClickAwayListener>
                        {isLoading1 && (
                          <CircularProgress
                            size={20}
                            style={{ marginLeft: "-40px", marginTop: "10px" }}
                          />
                        )}

                        {/* <p style={{ color: 'red', fontSize: '14px' }}>{errors.patientName?.message}</p> */}

                        {patient ? (
                          <div
                            className="col-xs-6"
                            style={{
                              padding: "5px",
                              fontSize: "0.875rem",
                              color: "#67748e",
                              borderRadius: "5px",
                              background: "white",
                              textAlign: "justify",
                              textJustify: "inter-word",
                              position: "absolute",
                              zIndex: "99",
                              width: "29%",
                              // height:'29%',
                              border: "1px solid #6cb5f9",
                              marginTop: "-10px",
                            }}
                          >
                            {patient ? (
                              patientData?.length > 0 ? (
                                patientData.map((s, index) => {
                                  var pat = `${patientData[index].lastName}, ${patientData[index].firstName}`;

                                  const searchTextLower =
                                    searchText.toLowerCase();
                                  const fullNameLower = pat.toLowerCase();
                                  const i =
                                    fullNameLower.indexOf(searchTextLower);

                                  if (i === -1) {
                                    return null;
                                  }

                                  const p1 = pat.substring(0, i);
                                  const p = pat.substring(
                                    i,
                                    i + searchText?.length,
                                  );
                                  const p2 = pat.substring(
                                    i + searchText?.length,
                                  );
                                  return (
                                    <p
                                      // attribZip={s.zipCode}
                                      // attribState={s.state}
                                      // attribCity={s.city}
                                      // attribIndex={index}
                                      style={PatientStyle}
                                      onClick={(ev) => {
                                        // var sel=ev.target.attributes['attribIndex']
                                        // console.log('Selected: ', patientData[index])
                                        setValue(
                                          "patientName",
                                          `${patientData[index].lastName}, ${patientData[index].firstName}`,
                                        );
                                        setValue(
                                          "patientId",
                                          patientData[index].id,
                                        );
                                        setPatientID(patientData[index].id);

                                        setPatientData([]);
                                        setPatientSelected(true);
                                        setPatient(false);
                                        setPatientNamee(
                                          `${patientData[index].lastName}, ${patientData[index].firstName}`,
                                        );
                                        setDocumentOpenError("");
                                      }}
                                      onBlur={(ev) => {
                                        setPatientData([]);
                                        setPatient(false);
                                      }}
                                      onChange={(ev) => {
                                        setPatientData([]);
                                        setPatientSelected(false);
                                        setPatient(false);
                                        setPatientNamee("");
                                      }}
                                    >
                                      <span>{p1}</span>
                                      <span
                                        style={{ backgroundColor: "yellow" }}
                                      >
                                        {p}
                                      </span>
                                      <span>{p2}</span>
                                    </p>
                                  );
                                })
                              ) : (
                                <Typography>No Record found</Typography>
                              )
                            ) : null}
                          </div>
                        ) : (
                          ""
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        <Controller
                          name="subject"
                          {...register("subject")}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              size="small"
                              placeholder="Please enter Subject"
                              {...field}
                              fullWidth
                              {...(selectedRowData.subject
                                ? { value: selectedRowData.subject }
                                : {})}
                              value={subject}
                              onChange={(e) => {
                                setsubject(e.target.value);
                                setValue("subject", e.target.value);
                                // setapptypeError(false)
                              }}
                              error={!!errors.subject}
                              helperText={
                                errors.subject ? errors.subject.message : ""
                              }
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={6} style={{ fontWeight: 500 }}>
                        <Typography
                          color="black"
                          variant="caption"
                          fontSize="15px"
                        >
                          Created Date
                        </Typography>
                      </Grid>
                      <Grid item xs={6} style={{ fontWeight: 500 }}>
                        <Typography
                          color="black"
                          variant="caption"
                          fontSize="15px"
                        >
                          Assigned To
                        </Typography>
                      </Grid>
                      <Grid item xs={6} style={{ fontWeight: 500 }}>
                        <Controller
                          name="createdDate"
                          {...register("createdDate")}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              type="date"
                              size="small"
                              fullWidth
                              // {...field}
                              value={dueDate}
                              placeholder="Enter Due date"
                              // {...(selectedRowData.createdDate ? { value: formatDate(selectedRowData.createdDate) } : {})}

                              onChange={(e) => {
                                setValue("createdDate", e.target.value);
                                setdueDate(e.target.value);
                              }}
                              // error={errors.createdDate}
                            />
                          )}
                        />
                        {/* <p style={{ color: "red", fontSize: "14px" }}>
                {errors.createdDate?.message}
              </p> */}
                      </Grid>
                      <Grid item xs={6} style={{ fontWeight: 500 }}>
                        {/* <Controller
                      name='assignedTo'
                      {...register('assignedTo')}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type='test'
                          size='small'
                          fullWidth
                          {...field}

                        />
                      )}
                    /> */}
                        {/* {Bool == false ? ( */}
                        <ReactSelect
                          fullWidth
                          value={practicesList.find(
                            (option) => option.value == assignedTo,
                          )}
                          onChange={(e) => {
                            setAssignedTo(e.value);
                            setPracticeID(e.value);
                            setassignedToError(false);
                          }}
                          options={practicesList}
                        />
                        {/* ) : (
                          <TextField
                            size="small"
                            value={selectedRowData.createdBy}
                            fullWidth
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        )} */}
                        {assignedToError && (
                          <p style={{ color: "red", fontSize: "14px" }}>
                            Please Select User
                          </p>
                        )}
                      </Grid>
                      <Grid item xs={12} style={{ fontWeight: 500 }}>
                        <Typography
                          color="black"
                          variant="caption"
                          fontSize="15px"
                        >
                          Comments
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{ fontWeight: 500 }}>
                        <Controller
                          name="comments"
                          {...register("comments")}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              size="small"
                              multiline
                              minRows={3}
                              maxRows={5}
                              value={selectedRowData.comments}
                              placeholder="Please enter Comments"
                              {...field}
                              fullWidth
                              onChange={(e) => {
                                setValue("comments", e.target.value);
                              }}
                            />
                          )}
                        />
                      </Grid>
        

<Grid item xs={12} lg={12} sm={12}>
  <Box
    sx={{
      display: "flex",
      justifyContent: Bool ? "space-between" : "flex-end",
      alignItems: "center",
      mt: 3,
      mb: 1,
      gap: 2,
      flexWrap: "wrap",
    }}
  >
    {/* LEFT SIDE - Save & Archive */}
    {Bool && (
      <Button
        onClick={handleSubmit(SubmitAndArchived)}
        disabled={isSubmitting}
        variant="outlined"
        startIcon={<ArchiveOutlinedIcon sx={{ fontSize: 18 }} />}
        sx={{
          textTransform: "none",
          borderRadius: 2,
          fontSize: 13,
          fontWeight: 600,
          px: 2.5,
          py: 1,
          color: "#377562",
          borderColor: "#377562",
          bgcolor: "rgba(55,117,98,0.07)",
          transition: "all 0.2s ease",
          "&:hover": {
            bgcolor: "#377562",
            color: "#fff",
            borderColor: "#377562",
            boxShadow: "0 3px 8px rgba(55,117,98,0.2)",
          },
          "&:disabled": {
            opacity: 0.6,
          },
        }}
      >
        Save & Archive
      </Button>
    )}

    {/* RIGHT SIDE - Cancel & Save */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <Button
        onClick={handleClose}
        variant="outlined"
        disabled={isSubmitting}
        sx={{
          textTransform: "none",
          borderRadius: 2,
          fontSize: 13,
          fontWeight: 600,
          px: 2.5,
          py: 1,
          color: "#6b7280",
          borderColor: "#e5e7eb",
          "&:hover": {
            bgcolor: "#f3f4f6",
            borderColor: "#d1d5db",
            color: "#374151",
          },
        }}
      >
        Cancel
      </Button>

      <Button
        onClick={handleSubmit(onSubmit)}
        disabled={isSubmitting}
        variant="contained"
        startIcon={<SaveOutlinedIcon sx={{ fontSize: 18 }} />}
        sx={{
          textTransform: "none",
          borderRadius: 2,
          fontSize: 13,
          fontWeight: 600,
          px: 3,
          py: 1,
          bgcolor: "#377562",
          color: "#fff",
          boxShadow: "0 2px 8px rgba(55,117,98,0.22)",
          transition: "all 0.2s ease",
          "&:hover": {
            bgcolor: "#2c5e4e",
            boxShadow: "0 4px 12px rgba(55,117,98,0.3)",
            transform: "translateY(-1px)",
          },
          "&:disabled": {
            bgcolor: "#a3b8b1",
            color: "#fff",
            boxShadow: "none",
          },
        }}
      >
        {isSubmitting ? "Saving..." : "Save"}
      </Button>
    </Box>
  </Box>
</Grid>


                    </Grid>
                  </Box>
                </Modal>
                <Modal
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  onClose={handleClose}
                  open={opendocs}
                >
                  <Box sx={styleofmodal}>
                    <Grid container>
                      <Grid item xs={9}>
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                          style={{
                            fontWeight: 500,
                            backgroundColor: "#377562",
                            marginBottom: 5,
                            color: "white",
                          }}
                        >
                          {FullDocName[0]}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        {submitting ? (
                          <LoadingButton
                            loading
                            loadingIndicator="Downloading"
                            // style={{ position: 'absolute', right: '28px', bottom: '11px' }}
                            color="primary"
                            variant="contained"
                          >
                            Fetch data
                          </LoadingButton>
                        ) : (
                          <Button
                            className="Button"
                            size="small"
                            startIcon={<Download />}
                            onClick={() => {
                              download(`${urldownload}`, FullDocName);
                            }}
                            variant="contained"
                            disabled={submitting}
                            style={{
                              // backgroundColor: 'primary',
                              color: "white",
                              float: "right",
                              // position: 'absolute',
                              // marginRight: '28px',
                              // bottom: '11px'
                            }}
                          >
                            Download
                          </Button>
                        )}
                      </Grid>
                      <Grid item xs={1}>
                        <CancelOutlinedIcon
                          onClick={() => setopendocs(false)}
                          fontSize="large"
                          color="red"
                          cursor="pointer"
                          style={{
                            color: "red",
                            marginBottom: 5,
                            float: "right",
                          }}
                        ></CancelOutlinedIcon>
                      </Grid>
                      {/* <Grid item xs={2}></Grid> */}

                      {(DocName && DocName == "jpg") ||
                      DocName == "png" ||
                      DocName == "jpeg" ? (
                        <>
                          <Grid item xs={2}></Grid>
                          <Grid item xs={8}>
                            <img
                              height="500px"
                              width="500px"
                              border="4px solid #000"
                              // frameborder='0'
                              // overflow='hidden'
                              src={`${urlFile}`}
                              // src={`https://images.unsplash.com/photo-1672394423014-e0354d75b123?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60`}
                            ></img>
                          </Grid>
                          <Grid item xs={2}></Grid>
                        </>
                      ) : (
                        <>
                          <Grid item xs={12}>
                            <iframe
                              height="500px"
                              width="875px"
                              // frameborder='0'
                              // overflow='hidden'
                              src={`${urlFile}`}
                              // src={`https://images.unsplash.com/photo-1672394423014-e0354d75b123?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60`}
                            ></iframe>
                          </Grid>
                        </>
                      )}
                      {/* <Grid item xs={2}></Grid> */}
                      <Grid item xs={12}></Grid>
                    </Grid>
                  </Box>
                </Modal>
              </Box>
            </Box>
            <Divider sx={{ mt: 0, mb: 1 }} />
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="lab API tabs example"
                >
                  <Tab
                    onClick={() => {
                      setMessage("New");
                    }}
                    value={0}
                    label={
                      <span>
                        Inbox{" "}
                        <span style={{ color: "green" }}>({Totalcount})</span>
                      </span>
                    }
                  />
                  <Tab
                    onClick={() => {
                      setMessage("Resolved");
                    }}
                    value={1}
                    label={
                      <span>
                        Sent{" "}
                        <span style={{ color: "green" }}>({SentCount})</span>
                      </span>
                    }
                  />

                  {rights.Archive_View && (
                    <Tab
                      onClick={() => {
                        setMessage("Archived");
                      }}
                      value={2}
                      label={
                        <span>
                          Archieved{" "}
                          <span style={{ color: "green" }}>
                            ({ArchievedCount})
                          </span>
                        </span>
                      }
                    />
                  )}
                </TabList>
              </Box>
              <TabPanel value={1}>
                {isLoading ? (
                  <div style={{ margin: "5rem", textAlign: "center" }}>
                    <CircularProgress />
                  </div>
                ) : (
                  <MenuItem
                    sx={{ p: 0, marginRight: "10px", marginTop: "-15px" }}
                  >
                    <Box sx={style}>
                      {Notification1 != null && Notification1?.length > 0
                        ? Notification1.map((row, index) => {
                            const documentParts = row.documents.split("@@");

                            return (
                              <Paper
                                variant="outlined"
                                square
                                key={row.id}
                                style={{
                                  backgroundColor: "#F0F6F8",
                                  // backgroundColor: row.redbit ? '#F0F6F8' : '#D4E7C5',
                                  borderRadius: "15px",
                                  marginTop: "5px",
                                  borderColor: "#377562",
                                  maxWidth: "100%",
                                  padding: ".9rem",
                                  marginBottom: "1rem",
                                  marginLeft: "0 .2rem",
                                }}
                              >
                                <Grid
                                  container
                                  spacing={2}
                                  item
                                  xs={12}
                                  sm={12}
                                  xl={12}
                                >
                                  <Grid container>
                                    <Grid
                                      item
                                      xs={3}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        Subject:
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={9}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          maxWidth: "100%",
                                          wordWrap: "break-word",
                                          whiteSpace: "pre-wrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "block",
                                        }}
                                      >
                                        {row.subject}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "20px",
                                          marginTop: "2px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px", // space between text and button
                                        }}
                                      >
                                        Patient Name:{" "}
                                        <span style={{ fontWeight: 600 }}>
                                          {row.patientName}
                                        </span>
                                        <Button
                                          variant="outlined"
                                          size="small"
                                          sx={{
                                            textTransform: "none",
                                            padding: "2px 8px",
                                            fontSize: "12px",
                                            borderRadius: "8px",
                                            borderColor: "#1976d2",
                                            color: "#1976d2",
                                            "&:hover": {
                                              backgroundColor: "#1976d2",
                                              color: "#fff",
                                            },
                                          }}
                                          onClick={() => {
                                            setOpenpatientreg(true);
                                            setpid(row.patientId);
                                          }}
                                        >
                                          Go to Profile
                                        </Button>
                                      </Typography>
                                    </Grid>

                                    <Grid
                                      item
                                      xs={3}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        Assigned To:
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={8}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          marginLeft: "30px",
                                        }}
                                      >
                                        {row.assignedTo}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={3}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        Date:
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={8}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        {Moment(row.createdDate).format(
                                          "DD-MM-YYYY",
                                        )}
                                      </Typography>
                                    </Grid>
                                    {/* <Grid item xs={3} style={{ fontWeight: 500 }}></Grid> */}
                                    <Grid
                                      item
                                      xs={3}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        Comments:
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={8}
                                      style={{ fontWeight: 450 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          maxWidth: "100%",
                                          marginLeft: "20px",
                                          wordWrap: "break-word",
                                          whiteSpace: "pre-wrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "block",
                                          textAlign: "justify",
                                        }}
                                      >
                                        {row.comments}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={11}
                                      style={{ fontWeight: 500 }}
                                    >
                                      {row.documents &&
                                        row.documents
                                          .split(";")
                                          .filter(Boolean) // remove empty values
                                          .map((doc, index) => {
                                            const [fileName, filePath] =
                                              doc.split("@@"); // split name and path
                                            return (
                                              <a
                                                key={index}
                                                href="#"
                                                style={{
                                                  fontSize: "13px",
                                                  marginBottom: "6px",
                                                  marginLeft: "25px",
                                                  borderBottom:
                                                    "1px solid black",
                                                  maxWidth: "100%",
                                                  wordWrap: "break-word",
                                                  whiteSpace: "pre-wrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  display: "block",
                                                }}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setopendocs(true);
                                                  seturldownload(filePath);

                                                  axios
                                                    .get(
                                                      `${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${filePath}`,
                                                      { headers },
                                                    )
                                                    .then((response) => {
                                                      seturlFile(response);
                                                    })
                                                    .catch((error) => {
                                                      console.error(
                                                        "There was an error!",
                                                        error,
                                                      );
                                                    });

                                                  setFullDocName(fileName);
                                                }}
                                              >
                                                {index + 1}. {fileName}{" "}
                                                {/* Show original file name */}
                                              </a>
                                            );
                                          })}
                                    </Grid>

                                    <Grid
                                      container
                                      alignItems="center"
                                      spacing={1}
                                      padding={"7px"}
                                    >
                                      <Grid item xs="auto">
                                        <Tooltip title="View Entire Message">
                                          <Button
                                            startIcon={
                                              <VisibilityIcon
                                                style={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              />
                                            }
                                            size="small"
                                            variant="contained"
                                            style={{
                                              fontSize: "11px",
                                              padding: "2px 6px",
                                              backgroundColor: "#4caf50", // green
                                              color: "white",
                                            }}
                                            onClick={() => {
                                              setPatientDataName(
                                                row.patientName,
                                              );
                                              setPatientdataId(row.id);
                                              // setPatientdataIds(row.parentId);
                                              handleRowClickChats(row);
                                              // setIsFirstCall(true)
                                            }}
                                          >
                                            View Entire Message
                                          </Button>
                                        </Tooltip>
                                      </Grid>

                                      <Grid item xs="auto">
                                        <Tooltip title="Archive to Chart">
                                          <Button
                                            startIcon={
                                              <ArchiveIcon
                                                style={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              />
                                            }
                                            size="small"
                                            variant="contained"
                                            style={{
                                              fontSize: "11px",
                                              padding: "2px 6px",
                                              backgroundColor: "#2196f3", // blue
                                              color: "white",
                                            }}
                                            onClick={() =>
                                              handleArchiveClick(
                                                row.id,
                                                "other",
                                              )
                                            }
                                          >
                                            Archive to Chart
                                          </Button>
                                        </Tooltip>
                                      </Grid>
                                    </Grid>

                                    <>
                                      {/* <Grid item xs={2} style={{ fontWeight: 500, marginLeft: '10px' }}>
                                    <Button
                                      className='Button'
                                      variant='gradient'
                                      onClick={() => {
                                        handleOpen(row);
                                        setBool(true);
                                      }}
                                      style={{
                                        color: 'white',
                                        fontSize: '13px',
                                        height: '27px',
                                        marginBottom: '3px',
                                        float: 'right'
                                      }}
                                    >

                                      Reply
                                    </Button>
                                  </Grid> */}

                                      {/* <Grid item xs={12} style={{ fontWeight: 500 }}>
                                    {row.id === id ? (
                                      <Box
                                        mb={2}
                                        sx={{
                                          marginBottom: '10px',

                                          marginTop: '15px',
                                          marginLeft: '10px'
                                        }}
                                      >
                                        <Grid container columnSpacing={1}>
                                          <Grid item xs={12} style={{ fontWeight: 500 }}>
                                            <Typography component='label' color='black' fontSize='15px'>
                                              Archive Comments:
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={12}>
                                            <Controller
                                              name='resolvedComments'
                                              {...register('resolvedComments')}
                                              control={control}
                                              render={({ field }) => (
                                                <TextareaAutosize
                                                  reset
                                                  aria-label='minimum height'
                                                  minRows={3}
                                                  placeholder='Enter comments'
                                                  style={{
                                                    width: '100%',
                                                    height: '60px',
                                                    borderRadius: '8px',
                                                    border: '2px solid #black',
                                                    overflow: 'scroll'
                                                  }}
                                                  value={resolvedComments}
                                                  onChange={e => {
                                                    setValue('resolvedComments', e.target.value)
                                                    setResolvedComments(e.target.value);
                                                    // setcompletedDate(e.target.value)
                                                    // setcompeleterror(false)
                                                  }}
                                                  // {...field}
                                                  fullWidth
                                                  error={errors.resolvedComments}
                                                />
                                              )}
                                            />
                                            <p style={{ color: 'red', fontSize: '14px' }}>
                                              {errors.resolvedComments?.message}
                                            </p>
                                          </Grid>
                                          <Grid item xs={4} style={{ fontWeight: 500, marginTop: '10px' }}>
                                            <Typography color='black' variant='caption' fontSize='15px'>
                                              Archive Date:
                                            </Typography>
                                          </Grid>

                                          <Grid item xs={8}>
                                            <Controller
                                              name='resolvedDate'
                                              {...register('date')}
                                              control={control}
                                              render={({ field }) => (
                                                <TextField
                                                  type='date'
                                                  size='small'
                                                  fullWidth
                                                  {...field}
                                                  value={resolvedDate}
                                                  placeholder='Enter resolve date'
                                                  // value={completedDate}
                                                  onChange={e => {
                                                    setValue('resolvedDate', e.target.value)
                                                    setResolvedDate(e.target.value);
                                                    // setcompletedDate(e.target.value)
                                                    // setcompeleterror(false)
                                                  }}
                                                />
                                              )}
                                            />
                                            {errorMessage && (
                                              <p style={{ color: 'red' }}>Please Select Date</p>
                                            )}
                                          </Grid>

                                          <Grid item xs={8} lg={6} sm={6}>
                                            <Button
                                              className='Button'
                                              onClick={() => saveData(row)}
                                              variant='gradient'

                                              style={{
                                                marginTop: '15px',
                                                marginBottom: '10px',
                                                float: 'right',
                                                width: '87px',
                                                height: '28px',
                                                // backgroundColor: '#56CA00',
                                                color: 'white',
                                                fontSize: '12px',
                                                marginRight: '-50px'
                                              }}
                                            // disabled={submitting}
                                            >
                                              <SaveOutlinedIcon
                                                fontSize='medium'
                                                style={{
                                                  color: 'white',
                                                  paddingRight: '5px',
                                                  paddingBottom: '2px'
                                                }}
                                              ></SaveOutlinedIcon>
                                              Save
                                            </Button>
                                          </Grid>

                                          <Grid item xs={4} lg={6} sm={6}>
                                            <Button
                                              className='Button'
                                              onClick={() => {
                                                setid(null)
                                              }}
                                              variant='gradient'
                                              style={{
                                                marginTop: '15px',
                                                marginBottom: '10px',
                                                float: 'right',
                                                width: '87px',
                                                height: '28px',
                                                backgroundColor: '#56CA00',
                                                color: 'white',
                                                fontSize: '12px',
                                                marginRight: '18px'
                                              }}
                                            >
                                              <CancelOutlinedIcon
                                                fontSize='medium'
                                                style={{
                                                  color: 'white',
                                                  paddingRight: '5px',
                                                  paddingBottom: '2px'
                                                }}
                                              ></CancelOutlinedIcon>
                                              Cancel
                                            </Button>
                                          </Grid>
                                        </Grid>
                                      </Box>
                                    ) : (
                                      <></>
                                    )}
                                  </Grid> */}
                                    </>
                                  </Grid>

                                  <Divider />
                                </Grid>
                              </Paper>
                            );
                          })
                        : "No Record Found"}
                      <Divider />
                    </Box>
                  </MenuItem>
                )}
              </TabPanel>
              <TabPanel value={0}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  {/* All Checkbox */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Checkbox
                      checked={isChecked === "all"}
                      size="small"
                      onClick={() =>
                        setIsChecked(isChecked === "all" ? "inbox" : "all")
                      }
                    />
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                      All{" "}
                      {isChecked === "all" && (
                        <span style={{ color: "#2e7d32", fontWeight: 600 }}>
                          ({Inboxcount})
                        </span>
                      )}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Checkbox
                      checked={ShowAsList}
                      size="small"
                      onClick={() => {
                        setShowAsList((prev) => !prev);
                      }}
                    />
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                      View as List
                    </Typography>
                  </Box>
                </Box>
                {isLoading ? (
                  <div style={{ margin: "5rem", textAlign: "center" }}>
                    <CircularProgress />
                  </div>
                ) : (
                  <MenuItem
                    sx={{ p: 0, marginRight: "10px", marginTop: "-15px" }}
                  >
                    <Box sx={stylesss}>
                      {Data != null && Data?.length > 0 ? (
                        Data.map((row, index) => {
                          const documentParts = row.documents.split("@@");

                          if (ShowAsList) {
                            // Compact List View (Gmail-style)
                            return (
                              <Paper
                                key={index}
                                variant="outlined"
                                square
                                style={{
                                  backgroundColor: row.seen
                                    ? "#F0F6F8"
                                    : "#D4E7C5",
                                  borderRadius: "8px",
                                  marginTop: "4px",
                                  marginBottom: "4px",
                                  borderColor: "#377562",
                                  maxWidth: "100%",
                                  padding: "12px 16px",
                                  cursor: "pointer",
                                  transition: "all 0.2s",
                                  "&:hover": {
                                    backgroundColor: row.seen
                                      ? "#E8F0FE"
                                      : "#C6E0B4",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  },
                                }}
                                onClick={() => {
                                  setPatientDataName(row.patientName);
                                  setPatientdataId(row.id);
                                  handleRowClickChats(row);
                                  HandleRead(row.id);
                                }}
                              >
                                <Grid container alignItems="center" spacing={2}>
                                  {/* Main Content */}
                                  <Grid item xs={8}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        mb: 0.5,
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontWeight: row.seen ? 500 : 700,
                                          fontSize: "14px",
                                          color: "#202124",
                                        }}
                                      >
                                        {row.patientName}
                                      </Typography>
                                      <Chip
                                        label={Moment(row.createdDate).format(
                                          "MMM DD",
                                        )}
                                        size="small"
                                        sx={{
                                          height: 20,
                                          fontSize: "11px",
                                          bgcolor: "#f1f3f4",
                                          color: "#5f6368",
                                        }}
                                      />
                                    </Box>

                                    <Typography
                                      sx={{
                                        fontWeight: row.seen ? 400 : 600,
                                        fontSize: "14px",
                                        color: row.seen ? "#5f6368" : "#202124",
                                        mb: 0.5,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {row.subject}
                                    </Typography>

                                    <Typography
                                      sx={{
                                        fontSize: "13px",
                                        color: "#5f6368",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {row.comments?.substring(0, 100)}
                                      {row.comments?.length > 100 ? "..." : ""}
                                    </Typography>
                                  </Grid>

                                  {/* Actions */}
                                  <Grid
                                    item
                                    xs={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      gap: 1,
                                    }}
                                  >
                                    {row.documents &&
                                      row.documents.split(";").filter(Boolean)
                                        .length > 0 && (
                                        <AttachmentIcon
                                          sx={{
                                            color: "#5f6368",
                                            fontSize: 18,
                                          }}
                                          titleAccess={`${row.documents.split(";").filter(Boolean).length} attachment(s)`}
                                        />
                                      )}

                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleOpen(row);
                                        setBool(true);
                                      }}
                                      title="Reply"
                                      sx={{ color: "#1976d2" }}
                                    >
                                      <ReplyIcon fontSize="small" />
                                    </IconButton>

                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleArchiveClick(row.id, "other");
                                      }}
                                      title="Archive"
                                      sx={{ color: "#5f6368" }}
                                    >
                                      <ArchiveIcon fontSize="small" />
                                    </IconButton>

                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenpatientreg(true);
                                        setpid(row.patientId);
                                      }}
                                      title="Go to Profile"
                                      sx={{ color: "#34a853" }}
                                    >
                                      <PersonIcon fontSize="small" />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </Paper>
                            );
                          }

                          // Original Detailed View
                          return (
                            <Paper
                              key={index}
                              variant="outlined"
                              square
                              style={{
                                backgroundColor:
                                  row.seen == true ? "#F0F6F8" : "#D4E7C5",
                                borderRadius: "15px",
                                marginTop: "5px",
                                borderColor: "#377562",
                                maxWidth: "100%",
                                padding: ".9rem",
                                marginBottom: "1rem",
                                marginLeft: "0 .2rem",
                              }}
                            >
                              {/* Original detailed view code remains the same */}
                              <Grid
                                container
                                spacing={2}
                                item
                                xs={12}
                                sm={12}
                                xl={12}
                              >
                                <Grid container>
                                  <Grid item xs={9} style={{ fontWeight: 500 }}>
                                    <Typography
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        marginLeft: "20px",
                                        marginTop: "2px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      Patient Name:{" "}
                                      <span style={{ fontWeight: 600 }}>
                                        {row.patientName}
                                      </span>
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={3} style={{ fontWeight: 500 }}>
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      sx={{
                                        textTransform: "none",
                                        padding: "2px 8px",
                                        fontSize: "12px",
                                        borderRadius: "8px",
                                        marginTop: "2px",
                                        borderColor: "#1976d2",
                                        color: "#1976d2",
                                        "&:hover": {
                                          backgroundColor: "#1976d2",
                                          color: "#fff",
                                        },
                                      }}
                                      onClick={() => {
                                        setOpenpatientreg(true);
                                        setpid(row.patientId);
                                      }}
                                    >
                                      Go to Profile
                                    </Button>
                                  </Grid>

                                  <Grid item xs={3} style={{ fontWeight: 500 }}>
                                    <Typography
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        marginLeft: "20px",
                                      }}
                                    >
                                      Subject:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={9} style={{ fontWeight: 500 }}>
                                    <Typography
                                      style={{
                                        fontSize: "14px",
                                        maxWidth: "100%",
                                        wordWrap: "break-word",
                                        whiteSpace: "pre-wrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "block",
                                      }}
                                    >
                                      {row.subject}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={3} style={{ fontWeight: 500 }}>
                                    <Typography
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        marginLeft: "20px",
                                      }}
                                    >
                                      From:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={9} style={{ fontWeight: 500 }}>
                                    <Typography
                                      style={{
                                        fontSize: "14px",
                                        maxWidth: "100%",
                                        wordWrap: "break-word",
                                        whiteSpace: "pre-wrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "block",
                                      }}
                                    >
                                      {row.createdBy}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={3} style={{ fontWeight: 500 }}>
                                    <Typography
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        marginLeft: "20px",
                                      }}
                                    >
                                      Date:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={9} style={{ fontWeight: 500 }}>
                                    <Typography style={{ fontSize: "14px" }}>
                                      {Moment(row.createdDate).format(
                                        "DD-MM-YYYY",
                                      )}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={3} style={{ fontWeight: 500 }}>
                                    <Typography
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        marginLeft: "20px",
                                      }}
                                    >
                                      Comments:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={9} style={{ fontWeight: 500 }}>
                                    <Typography
                                      style={{
                                        fontSize: "14px",
                                        maxWidth: "100%",
                                        marginLeft: "18px",
                                        wordWrap: "break-word",
                                        whiteSpace: "pre-wrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "block",
                                      }}
                                    >
                                      {row.comments}
                                    </Typography>
                                  </Grid>
                                  {row.lastMessage == "" ? (
                                    <></>
                                  ) : (
                                    <>
                                      <Grid
                                        item
                                        xs={4}
                                        style={{ fontWeight: 500 }}
                                      >
                                        <Typography
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            marginLeft: "20px",
                                          }}
                                        >
                                          Last Message:
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={8}
                                        style={{ fontWeight: 450 }}
                                      >
                                        <Typography
                                          style={{
                                            fontSize: "14px",
                                            maxWidth: "100%",
                                            marginLeft: "20px",
                                            wordWrap: "break-word",
                                            whiteSpace: "pre-wrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            display: "block",
                                            textAlign: "justify",
                                          }}
                                        >
                                          {row.lastMessage}
                                        </Typography>
                                      </Grid>
                                    </>
                                  )}

                                  <>
                                    <Grid
                                      item
                                      xs={4}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        Practice Name:
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={8}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          maxWidth: "100%",
                                          marginLeft: "18px",
                                          wordWrap: "break-word",
                                          whiteSpace: "pre-wrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "block",
                                        }}
                                      >
                                        {row.practiceName}
                                      </Typography>
                                    </Grid>
                                  </>

                                  <Grid
                                    item
                                    xs={11}
                                    style={{ fontWeight: 500 }}
                                  >
                                    {row.documents &&
                                      row.documents
                                        .split(";")
                                        .filter(Boolean) // remove empty values
                                        .map((doc, index) => {
                                          const [fileName, filePath] =
                                            doc.split("@@"); // split name and path
                                          return (
                                            <a
                                              key={index}
                                              href="#"
                                              style={{
                                                fontSize: "13px",
                                                marginBottom: "6px",
                                                marginLeft: "25px",
                                                borderBottom: "1px solid black",
                                                maxWidth: "100%",
                                                wordWrap: "break-word",
                                                whiteSpace: "pre-wrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                display: "block",
                                              }}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setopendocs(true);
                                                seturldownload(filePath);

                                                axios
                                                  .get(
                                                    `${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${filePath}`,
                                                    { headers },
                                                  )
                                                  .then((response) => {
                                                    seturlFile(response);
                                                  })
                                                  .catch((error) => {
                                                    console.error(
                                                      "There was an error!",
                                                      error,
                                                    );
                                                  });

                                                setFullDocName(fileName);
                                              }}
                                            >
                                              {index + 1}. {fileName}
                                            </a>
                                          );
                                        })}
                                  </Grid>

                                  <Grid item xs={1}></Grid>
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                    padding={"7px"}
                                  >
                                    {isChecked === "all" &&
                                      rights.Notification_Mark_Unread_Button && (
                                        <Grid item xs="auto">
                                          <Button
                                            startIcon={
                                              <MarkUnreadChatAltIcon
                                                style={{
                                                  fontSize: 16,
                                                  color: "white",
                                                }}
                                              />
                                            }
                                            onClick={() => {
                                              HandleUnRead(row.id);
                                              setPatientdataId(row.id);
                                            }}
                                            variant="contained"
                                            style={{
                                              fontSize: "11px",
                                              minWidth: "90px",
                                              padding: "2px 6px",
                                              backgroundColor: "#f44336", // red
                                              color: "white",
                                            }}
                                          >
                                            Mark Unread
                                          </Button>
                                        </Grid>
                                      )}

                                    <Grid item xs="auto">
                                      <Tooltip title="View Entire Message">
                                        <Button
                                          startIcon={
                                            <VisibilityIcon
                                              style={{
                                                fontSize: 16,
                                                color: "white",
                                              }}
                                            />
                                          }
                                          size="small"
                                          variant="contained"
                                          style={{
                                            fontSize: "11px",
                                            padding: "2px 6px",
                                            backgroundColor: "#4caf50", // green
                                            color: "white",
                                          }}
                                          onClick={() => {
                                            setPatientDataName(row.patientName);
                                            setPatientdataId(row.id);
                                            handleRowClickChats(row);
                                            HandleRead(row.id);
                                          }}
                                        >
                                          View Entire Message
                                        </Button>
                                      </Tooltip>
                                    </Grid>

                                    <Grid item xs="auto">
                                      <Tooltip title="Archive to Chart">
                                        <Button
                                          startIcon={
                                            <ArchiveIcon
                                              style={{
                                                fontSize: 16,
                                                color: "white",
                                              }}
                                            />
                                          }
                                          size="small"
                                          variant="contained"
                                          style={{
                                            fontSize: "11px",
                                            padding: "2px 6px",
                                            backgroundColor: "#2196f3", // blue
                                            color: "white",
                                          }}
                                          onClick={() =>
                                            handleArchiveClick(row.id, "other")
                                          }
                                        >
                                          Archive to Chart
                                        </Button>
                                      </Tooltip>
                                    </Grid>

                                    <Grid item xs="auto">
                                      <Button
                                        startIcon={
                                          <ReplyIcon
                                            style={{
                                              fontSize: 16,
                                              color: "white",
                                            }}
                                          />
                                        }
                                        size="small"
                                        variant="contained"
                                        style={{
                                          fontSize: "11px",
                                          minWidth: "70px",
                                          padding: "2px 6px",
                                          backgroundColor: "#ff9800", // orange
                                          color: "white",
                                        }}
                                        onClick={() => {
                                          handleOpen(row);
                                          setBool(true);
                                        }}
                                      >
                                        Reply
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Divider />
                              </Grid>
                            </Paper>
                          );
                        })
                      ) : (
                        <Box
                          sx={{
                            textAlign: "center",
                            padding: "40px",
                            color: "#5f6368",
                            fontSize: "14px",
                          }}
                        >
                          No Record Found
                        </Box>
                      )}
                    </Box>
                  </MenuItem>
                )}
                <Dialog
                  open={isDialogOpen}
                  onClose={() => setDialogOpen(false)}
                  aria-labelledby="delete-dialog-title"
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    invisible: true,
                  }}
                  PaperProps={{
                    style: {
                      marginRight: "5px",
                      float: "right",
                      marginTop: "5px",
                      color: "red",
                      cursor: "pointer",
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center", // Center horizontally
                      justifyContent: "center", // Center vertically
                      borderRadius: "8px",
                      width: "500px",
                    }}
                  >
                    <ErrorOutlineIcon
                      style={{ fontSize: "100px", color: "red" }}
                    />
                    <DialogTitle
                      style={{
                        fontWeight: "bold",
                        color: "black",
                        fontSize: "1.25rem",
                      }}
                    >
                      Are you sure?
                    </DialogTitle>
                    <h5
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "normal",
                        color: "#444444",
                      }}
                    >
                      Reopen this Patient!
                    </h5>
                    <DialogContent>
                      <DialogContentText>
                        <Grid style={{ marginTop: "1rem" }}>
                          <Button
                            onClick={() => setDialogOpen(false)}
                            style={{
                              backgroundColor: "#6c7c84",
                              color: "white",
                              marginBottom: "1rem",
                            }}
                          >
                            No, cancel!
                          </Button>
                          <Button
                            onClick={handlecolseConfirmArchive}
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              marginLeft: "1rem",
                              marginBottom: "1rem",
                              border: "1px solid #b4acec",
                            }}
                          >
                            Yes, Reopen it!
                          </Button>
                        </Grid>
                      </DialogContentText>
                    </DialogContent>
                  </div>
                </Dialog>
              </TabPanel>
              <TabPanel value={2}>
                {isLoading ? (
                  <div style={{ margin: "5rem", textAlign: "center" }}>
                    <CircularProgress />
                  </div>
                ) : (
                  <MenuItem
                    sx={{ p: 0, marginRight: "10px", marginTop: "-15px" }}
                  >
                    <Box sx={style}>
                      {ArchiveData != null && ArchiveData?.length > 0
                        ? ArchiveData.map((row, index) => {
                            return (
                              <Paper
                                variant="outlined"
                                square
                                style={{
                                  backgroundColor: "#F0F6F8",
                                  borderRadius: "15px",
                                  marginTop: "5px",
                                  borderColor: "#377562",
                                  maxWidth: "100%",
                                  padding: ".9rem",
                                  marginBottom: "1rem",
                                  marginLeft: "0 .2rem",
                                }}
                              >
                                <Grid
                                  container
                                  spacing={2}
                                  item
                                  xs={12}
                                  sm={12}
                                  xl={12}
                                >
                                  <Grid container>
                                    <Grid
                                      item
                                      xs={12}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "20px",
                                          marginTop: "2px",
                                        }}
                                      >
                                        Patient Name : {row.patientName}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={3}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        Subject:
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={9}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          maxWidth: "100%",
                                          wordWrap: "break-word",
                                          whiteSpace: "pre-wrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "block",
                                        }}
                                      >
                                        {row.subject}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={3}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        Assigned To:
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={9}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          marginLeft: "28px",
                                          marginBottom: "5px",
                                        }}
                                      >
                                        {row.assignedTo}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={3}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "25px",
                                        }}
                                      >
                                        Date:
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={9}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography style={{ fontSize: "14px" }}>
                                        {row.createdDate}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={3}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "25px",
                                        }}
                                      >
                                        Comments:
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={9}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          maxWidth: "100%",
                                          marginLeft: "18px",
                                          wordWrap: "break-word",
                                          whiteSpace: "pre-wrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "block",
                                        }}
                                      >
                                        {row.comments}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={5}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          marginLeft: "25px",
                                        }}
                                      >
                                        Archived Date:
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={7}
                                      style={{ fontWeight: 500 }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "14px",
                                          maxWidth: "100%",
                                          marginLeft: "18px",
                                          wordWrap: "break-word",
                                          whiteSpace: "pre-wrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "block",
                                        }}
                                      >
                                        {row.resolvedDate}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={10}></Grid>
                                    <Grid item xs={2}>
                                      <>
                                        <Button
                                          className="Button"
                                          onClick={() => {
                                            setDelbyid(row.id);
                                            setPatientiidresolve(row.patientId);
                                            setsubject1(row.subject);
                                            setName1(row.patientName);
                                            setassginedto(row.assignedTo);
                                            setdate(row.createdDate);
                                            setcommentsnotifcation(
                                              row.comments,
                                            );
                                            setDialogOpen(true);
                                          }}
                                          variant="gradient"
                                          style={{
                                            marginTop: "30px",
                                            marginBottom: "10px",
                                            float: "right",
                                            marginLeft: "auto",
                                            width: "90px",
                                            height: "35px",
                                            color: "white",
                                            fontSize: "14px",
                                          }}
                                        >
                                          <RestartAltIcon
                                            fontSize="medium"
                                            style={{
                                              color: "white",
                                              paddingRight: "5px",
                                              paddingBottom: "2px",
                                            }}
                                          ></RestartAltIcon>
                                          ReOpen
                                        </Button>
                                      </>
                                    </Grid>
                                  </Grid>

                                  <Divider />
                                </Grid>
                              </Paper>
                            );
                          })
                        : "No Record Found"}
                      <Divider />
                    </Box>
                  </MenuItem>
                )}
                <Dialog
                  open={isDialogOpen}
                  onClose={() => setDialogOpen(false)}
                  aria-labelledby="delete-dialog-title"
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    invisible: true,
                  }}
                  PaperProps={{
                    style: {
                      marginRight: "5px",
                      float: "right",
                      marginTop: "5px",
                      color: "red",
                      cursor: "pointer",
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center", // Center horizontally
                      justifyContent: "center", // Center vertically
                      borderRadius: "8px",
                      width: "500px",
                    }}
                  >
                    <ErrorOutlineIcon
                      style={{ fontSize: "100px", color: "red" }}
                    />
                    <DialogTitle
                      style={{
                        fontWeight: "bold",
                        color: "black",
                        fontSize: "1.25rem",
                      }}
                    >
                      Are you sure?
                    </DialogTitle>
                    <h5
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "normal",
                        color: "#444444",
                      }}
                    >
                      Reopen this Patient!
                    </h5>
                    <DialogContent>
                      <DialogContentText>
                        <Grid style={{ marginTop: "1rem" }}>
                          <Button
                            onClick={() => setDialogOpen(false)}
                            style={{
                              backgroundColor: "#6c7c84",
                              color: "white",
                              marginBottom: "1rem",
                            }}
                          >
                            No, cancel!
                          </Button>
                          <Button
                            onClick={handlecolseConfirmArchive}
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              marginLeft: "1rem",
                              marginBottom: "1rem",
                              border: "1px solid #b4acec",
                            }}
                          >
                            Yes, Reopen it!
                          </Button>
                        </Grid>
                      </DialogContentText>
                    </DialogContent>
                  </div>
                </Dialog>
              </TabPanel>
            </TabContext>
          </>
        </Popover>
        {/* newAdd */}
        <Badge
          // overlap='circular'
          onClick={handleDropdownOpen}
          sx={{ ml: 2, cursor: "pointer" }}
          //  badgeContent={<BadgeContentSpan />}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        ></Badge>
        {/* <Typography sx={{ fontWeight: 600, marginLeft: 5 }}>{admin}</Typography> */}
        <Popover
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => handleDropdownClose()}
          sx={{ "& .MuiMenu-paper": { width: 230, mt: 4 } }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <>
            <Box sx={{ pt: 2, pb: 3, px: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Badge
                  overlap="circular"
                  badgeContent={<BadgeContentSpan />}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                >
                  {/* <Avatar alt='John Doe' src='/images/avatars/1.png' sx={{ width: '2.5rem', height: '2.5rem' }} /> */}
                </Badge>
                <Box
                  sx={{
                    ml: 3,
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                ></Box>
              </Box>
            </Box>
            <Divider sx={{ mt: 0, mb: 1 }} />
          </>
        </Popover>
        <>
          <Modal
            open={OpenReply}
            onClose={handleCloseReply}
            aria-labelledby="conversation-modal-title"
            aria-describedby="conversation-modal-description"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& .MuiBackdrop-root": {
                backgroundColor: "rgba(0, 0, 0, 0.6)",
              },
            }}
          >
            <Box
              sx={{
                width: "90%",
                maxWidth: 800,
                maxHeight: "90vh",
                backgroundColor: "#F8F9FA",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Enhanced Header */}
              <Headroom>
                <Box
                  sx={{
                    backgroundColor: "#2C3E50",
                    background:
                      "linear-gradient(135deg, #2C3E50 0%, #4A6491 100%)",
                    padding: "16px 24px",
                    borderBottom: "3px solid #18BC9C",
                  }}
                >
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Grid item xs={8}>
                      <Box display="flex" alignItems="center" gap={2}>
                        <Box
                          sx={{
                            width: 50,
                            height: 50,
                            borderRadius: "50%",
                            backgroundColor: "#18BC9C",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "18px",
                          }}
                        >
                          {PatientDataName?.charAt(0) || "P"}
                        </Box>
                        <Box>
                          <Typography
                            variant="h6"
                            sx={{
                              color: "white",
                              fontWeight: "bold",
                              fontSize: "18px",
                            }}
                          >
                            {PatientDataName}
                          </Typography>
                          <Box display="flex" gap={2} mt={0.5}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#BDC3C7",
                                fontSize: "12px",
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              📝 {ReplyData?.length || 0} messages
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={4} textAlign="right">
                      <IconButton
                        onClick={handleCloseReply}
                        sx={{
                          color: "white",
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                          },
                          padding: "8px",
                        }}
                      >
                        <CancelOutlinedIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Box>
              </Headroom>

              {/* Conversation Area */}
              <Box
                sx={{
                  flex: 1,
                  overflowY: "auto",
                  padding: "20px",
                  backgroundColor: "#F8F9FA",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#ECF0F1",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#BDC3C7",
                    borderRadius: "4px",
                  },
                }}
              >
                {loadingReplies ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "250px",
                    }}
                  >
                    <CircularProgress size={40} />
                  </Box>
                ) : ReplyData && ReplyData.length > 0 ? (
                  ReplyData.map((row, index) => {
                    const isMyMessage = row.createdBy === Emailaddress;
                    const formattedDate = Moment(row.createdDate).format(
                      "MMM DD, YYYY hh:mm A",
                    );

                    return (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: isMyMessage ? "flex-end" : "flex-start",
                          marginBottom: "16px",
                        }}
                      >
                        {/* User Label */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 0.5,
                            px: 1,
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              fontWeight: "bold",
                              fontSize: "11px",
                              color: isMyMessage ? "#2C3E50" : "#7F8C8D",
                            }}
                          >
                            {isMyMessage ? (
                              <span style={{ color: "#18BC9C" }}>👤 You</span>
                            ) : (
                              `👤 ${row.createdBy}`
                            )}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: "10px",
                              color: "#95A5A6",
                            }}
                          >
                            {formattedDate}
                          </Typography>
                        </Box>

                        {/* Message Card */}
                        <Paper
                          elevation={2}
                          sx={{
                            maxWidth: "75%",
                            padding: "10px",
                            borderRadius: "18px",
                            backgroundColor: isMyMessage ? "#E8F6F3" : "white",
                            borderTopRightRadius: isMyMessage ? "4px" : "18px",
                            borderTopLeftRadius: isMyMessage ? "18px" : "4px",
                            border: "1px solid",
                            borderColor: isMyMessage ? "#A2D9CE" : "#D5DBDB",
                            position: "relative",
                            "&::before": {
                              content: '""',
                              position: "absolute",
                              top: "0",
                              [isMyMessage ? "right" : "left"]: "-8px",
                              width: "16px",
                              height: "16px",
                              backgroundColor: isMyMessage
                                ? "#E8F6F3"
                                : "white",
                              borderLeft: isMyMessage
                                ? "1px solid #A2D9CE"
                                : "none",
                              borderRight: isMyMessage
                                ? "none"
                                : "1px solid #D5DBDB",
                              borderBottom: isMyMessage
                                ? "1px solid #A2D9CE"
                                : "1px solid #D5DBDB",
                              transform: "rotate(45deg)",
                              zIndex: 1,
                            },
                          }}
                        >
                          {/* Subject Section */}
                          {row.subject && (
                            <Box
                              sx={{
                                mb: 1,
                                pb: 1,
                                borderBottom: "2px solid",
                                borderColor: isMyMessage
                                  ? "#18BC9C"
                                  : "#3498DB",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: "#2C3E50",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Subject
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: isMyMessage ? "#16A085" : "#2C3E50",
                                  fontWeight: "500",
                                }}
                              >
                                {row.subject}
                              </Typography>
                            </Box>
                          )}

                          {/* Comments Section */}
                          <Box sx={{ mb: 1 }}>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "#2C3E50",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              Message
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "14px",
                                lineHeight: 1.6,
                                color: "#34495E",
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              {row.comments}
                            </Typography>
                          </Box>

                          {/* Assigned To (if exists) */}
                          {row.assignedTo && (
                            <Box
                              sx={{
                                p: 1,
                                backgroundColor: "rgba(52, 152, 219, 0.1)",
                                borderRadius: "8px",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: "#2C3E50",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                  mb: 0.5,
                                }}
                              >
                                👥 Assigned To
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  color: "#2980B9",
                                  fontWeight: "500",
                                }}
                              >
                                {row.assignedTo}
                              </Typography>
                            </Box>
                          )}
                          {row.createdBy && (
                            <Box
                              sx={{
                                p: 1,
                                mt: 1,
                                backgroundColor: "rgba(159, 27, 168, 0.1)",
                                borderRadius: "8px",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: "#2C3E50",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                  mb: 0.5,
                                }}
                              >
                                👥 From
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  color: "#2980B9",
                                  fontWeight: "500",
                                }}
                              >
                                {row.createdBy}
                              </Typography>
                            </Box>
                          )}
                          {/* Documents Section */}
                          {row.documentName &&
                            row.documentName.split(";").filter(Boolean).length >
                              0 && (
                              <Box sx={{ mt: 1 }}>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    color: "#2C3E50",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    mb: 1.5,
                                  }}
                                >
                                  📁 Attachments
                                </Typography>
                                <Grid container spacing={1}>
                                  {row.documentName
                                    .split(";")
                                    .filter(Boolean)
                                    .map((doc, idx) => {
                                      const [fileName, filePath] =
                                        doc.split("@@");
                                      return (
                                        <Grid item xs={12} key={idx}>
                                          <Paper
                                            elevation={0}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setopendocs(true);
                                              seturldownload(filePath);

                                              axios
                                                .get(
                                                  `${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${filePath}`,
                                                  { headers },
                                                )
                                                .then((response) =>
                                                  seturlFile(response),
                                                )
                                                .catch(console.error);

                                              setFullDocName(fileName);
                                            }}
                                            sx={{
                                              padding: "10px 12px",
                                              backgroundColor:
                                                "rgba(231, 76, 60, 0.05)",
                                              border: "1px solid #E6E6E6",
                                              borderRadius: "8px",
                                              cursor: "pointer",
                                              transition: "all 0.2s ease",
                                              "&:hover": {
                                                backgroundColor:
                                                  "rgba(231, 76, 60, 0.1)",
                                                borderColor: "#E74C3C",
                                                transform: "translateY(-1px)",
                                              },
                                            }}
                                          >
                                            <Box
                                              display="flex"
                                              alignItems="center"
                                              gap={1.5}
                                            >
                                              <Box
                                                sx={{
                                                  width: 32,
                                                  height: 32,
                                                  borderRadius: "6px",
                                                  backgroundColor: "#E74C3C",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  color: "white",
                                                  fontSize: "14px",
                                                }}
                                              >
                                                📎
                                              </Box>
                                              <Box
                                                sx={{ flex: 1, minWidth: 0 }}
                                              >
                                                <Typography
                                                  sx={{
                                                    fontSize: "13px",
                                                    color: "#2C3E50",
                                                    fontWeight: "500",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {fileName}
                                                </Typography>
                                                <Typography
                                                  sx={{
                                                    fontSize: "11px",
                                                    color: "#7F8C8D",
                                                    mt: 0.25,
                                                  }}
                                                >
                                                  Click to view/download
                                                </Typography>
                                              </Box>
                                              <Box
                                                sx={{
                                                  width: 24,
                                                  height: 24,
                                                  borderRadius: "50%",
                                                  backgroundColor:
                                                    "rgba(231, 76, 60, 0.1)",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  color: "#E74C3C",
                                                }}
                                              >
                                                ↓
                                              </Box>
                                            </Box>
                                          </Paper>
                                        </Grid>
                                      );
                                    })}
                                </Grid>
                              </Box>
                            )}
                          <Button
                            variant="contained"
                            onClick={() => {
                              handleOpen(row);
                              setBool(true);
                            }}
                            sx={{
                              backgroundColor: "#2C3E50",
                              color: "white",
                              fontWeight: "bold",
                              fontSize: "14px",
                              padding: "8px",
                              margin: "8px",
                              float: "right",
                              borderRadius: "8px",
                              textTransform: "none",
                              "&:hover": {
                                backgroundColor: "#34495E",
                              },
                              boxShadow: "0 2px 8px rgba(44, 62, 80, 0.2)",
                              display: isMyMessage ? "none" : "flex",
                              textTransform: "uppercase",
                            }}
                          >
                            REPLY
                          </Button>
                        </Paper>
                      </Box>
                    );
                  })
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "200px",
                      textAlign: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        backgroundColor: "#ECF0F1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2,
                      }}
                    >
                      <span style={{ fontSize: "36px" }}>💬</span>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#7F8C8D",
                        mb: 1,
                      }}
                    >
                      No conversations yet
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#95A5A6",
                      }}
                    >
                      Start a conversation by adding the first message
                    </Typography>
                  </Box>
                )}
                <div ref={messagesEndRef} />
              </Box>

              {/* Footer */}
              <Box
                sx={{
                  padding: "16px 24px",
                  backgroundColor: "white",
                  borderTop: "1px solid #ECF0F1",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => handleArchiveClick(PatientDataId, "other")}
                  sx={{
                    color: "#fff",
                    backgroundColor: "#1E8449",
                    borderRadius: "8px",
                    padding: "10px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    transition: "0.3s ease",
                    "&:hover": {
                      backgroundColor: "#196F3D",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                    },
                    mr: 2,
                  }}
                  startIcon={<ArchiveIcon />}
                >
                  Archive Save to Chart
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCloseReply}
                  sx={{
                    backgroundColor: "#2C3E50",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "14px",
                    padding: "8px 24px",
                    borderRadius: "8px",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#34495E",
                    },
                    boxShadow: "0 2px 8px rgba(44, 62, 80, 0.2)",
                  }}
                  startIcon={<CancelOutlinedIcon />}
                >
                  Close Conversation
                </Button>
              </Box>
            </Box>
          </Modal>

          <Modal open={Archived} onClose={handleCloseDialog}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90%", sm: "400px" }, // Responsive width
                bgcolor: "background.paper",
                border: "5px solid #326C1D",
                borderRadius: "8px",
                boxShadow: 24,
                p: 4,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#326C1D",
                  fontWeight: 600,
                  textAlign: "center",
                  mb: 2,
                }}
              >
                Confirm Archive
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#333",
                  fontWeight: 500,
                  textAlign: "center",
                  mb: 4,
                }}
              >
                Are you sure you want to archive this item?
              </Typography>

              <Grid container spacing={2} justifyContent="flex-end">
                {" "}
                {/* Align items to the right */}
                <Grid item>
                  <Button
                    onClick={handleCloseDialog}
                    variant="contained"
                    sx={{
                      color: "#fff",
                      background: "#326C1D",
                      borderRadius: "20px",
                      fontSize: "14px",
                      height: "36px",
                      padding: "0 16px",
                      marginRight: "8px", // Add space between buttons
                    }}
                  >
                    Close
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    onClick={handleConfirmArchive}
                    variant="contained"
                    sx={{
                      color: "#fff",
                      background: "#326C1D",
                      borderRadius: "20px",
                      fontSize: "14px",
                      height: "36px",
                    }}
                  >
                    Yes
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Modal>
        </>
      </React.Fragment>
    </>
  );
};

export default NotificationDropdown;
